import Player from "../fbobjects/Player";
import FBOM from "../fbobjects/framework/FBOM";
import Simulation from "../fbobjects/Simulation";
import GoogleSheetDB from "../fbobjects/GoogleSheetDB";
import RiotDB from "../fbobjects/RiotDB";
import KillPageStore from "../fbobjects/KillPageStore";
import {AbilityImages} from "../fbobjects/KillPageStore";

export default class SimulationActions {

	static chooseChampion(player:Player, selectedChampion:string){
        (async() => {
            player.selectedChampion = selectedChampion;
            player.selectedSkillOrder = GoogleSheetDB.getDefaultSkillOrdersForChampion(selectedChampion);
            player.selectedRunes = GoogleSheetDB.getDefaultChampionRunesForChampion(selectedChampion);
            await Promise.all([FBOM.rSaveP(player),RiotDB.loadChampionAbilityIconsP(selectedChampion)]);
            KillPageStore.emitOnChange();
        })();
    }

    static addItem(player:Player, item:string, level:number){
        player.addItem(item, level);
        FBOM.rSaveP(player);
    }

    static removeItem(player:Player, item:any){
	    player.removeItem(item);
        FBOM.rSaveP(player);
    }

    static createSimulationP():Promise<Simulation>{
        return (async() => {
            let sim = new Simulation();

            sim.mePlayer = new Player();
            sim.themPlayer = new Player();


            await FBOM.rSaveP(sim);
            console.time('load simulation');
            sim = await FBOM.rLoadP(sim.id);
            console.timeEnd('load simulation');
            console.log('finished waiting for rSaveP');
            return FBOM.getObject(sim.id);
        })();
    }

    static _createDefaultPlayer(player, defaultChamp){
        if (player.selectedChampion == undefined){
            player.selectedChampion = defaultChamp;
        }
        player.selectedRunes = GoogleSheetDB.getDefaultChampionRunesForChampion(player.selectedChampion);
        player.selectedSkillOrder = GoogleSheetDB.getDefaultSkillOrdersForChampion(player.selectedChampion);
    }


    static loadSimulationP(id:string):Promise<Simulation>{

        //TODO change this back to just setting up default players with no selected champs.

        return (async() => {
            let sim:Simulation = await FBOM.rLoadP(id);
            let needSave = false;

            if(sim.mePlayer == undefined){
                sim.mePlayer = new Player();
                needSave = true;
            }

            if (sim.mePlayer.selectedChampion == undefined){
                SimulationActions._createDefaultPlayer(sim.mePlayer,"Jayce");
                needSave = true;
            }


            if(sim.themPlayer == undefined){
                sim.themPlayer = new Player();
                needSave = true;
            }

            if (sim.themPlayer.selectedChampion == undefined){
                SimulationActions._createDefaultPlayer(sim.themPlayer,"Annie");
                needSave = true;
            }

            if (needSave == true){
                await FBOM.rSaveP(sim);
            }
            return sim;
        })();

    }

}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/SimulationActions.ts